import React, { useState, useEffect } from "react";
import { Button, Table, Space, Select, Tag, Input } from "@ant-design/icons";
import { PlusOutlined, EditOutlined, DeleteOutlined, SearchOutlined, EyeOutlined } from "@ant-design/icons";
import { Button as AntButton, Table as AntTable, Space as AntSpace, Select as AntSelect, Tag as AntTag, Input as AntInput, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";

const { Option } = AntSelect;

const MachineryRegisterList = () => {
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [ships, setShips] = useState([]);
    const [selectedShipId, setSelectedShipId] = useState("");
    const [searchText, setSearchText] = useState("");

    const fetchShips = async () => {
        try {
            const FORM_DATA = new FormData();
            const res = await post(ApiURL.list_ships_view_com, FORM_DATA);
            if (res?.status === true) {
                setShips(res?.ships || []);
            }
        } catch (error) {
            console.error("Error fetching ships:", error);
        }
    };

    const fetchMachinery = async (shipId) => {
        setLoader(true);
        try {
            const FORM_DATA = new FormData();
            const user_Data = JSON.parse(localStorage.getItem("user_data"));
            FORM_DATA.append("company_id", user_Data?.data?.company?.company_id);
            if (shipId) {
                FORM_DATA.append("ship_id", shipId);
            }
            
            const res = await post(ApiURL.list_machinery, FORM_DATA);
            if (res?.status === true) {
                // Support both 'data' and 'response_data'
                setDataSource(res?.data || res?.response_data || []);
            } else {
                setDataSource([]);
            }
        } catch (error) {
            console.error("Error fetching machinery:", error);
            setDataSource([]);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchShips();
        fetchMachinery("");
    }, []);

    const handleShipChange = (value) => {
        setSelectedShipId(value);
        fetchMachinery(value);
    };

    const columns = [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            align: 'center',
        },
        {
            title: "Name",
            key: "machinery_name",
            align: 'center',
            render: (_, record) => record.machinery_name || record.machinary_name || "N/A"
        },
        {
            title: "Category",
            key: "category",
            align: 'center',
            render: (_, record) => {
                const cat = record.category || record.machinary_selected_dropdown;
                return <AntTag color="blue">{cat || "N/A"}</AntTag>;
            }
        },
        {
            title: "Manufacturer",
            key: "manufacturer",
            align: 'center',
            render: (_, record) => record.manufacturer || record.machinary_make || "N/A"
        },
        {
            title: "Model",
            key: "model",
            align: 'center',
            render: (_, record) => record.model || record.machinary_model || "N/A"
        },
        {
            title: "Serial No.",
            dataIndex: "serial_number",
            key: "serial_number",
            align: 'center',
            render: (text) => text || "N/A"
        },
        {
            title: "Running Hours",
            dataIndex: "running_hours",
            key: "running_hours",
            align: 'center',
            render: (text) => text || "0"
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            align: 'center',
            render: (status) => (
                <AntTag color={status === true || status === "true" || status === "Active" ? "green" : "red"}>
                    {status === true || status === "true" || status === "Active" ? "Active" : "Inactive"}
                </AntTag>
            ),
        },
        {
            title: "Action",
            key: "action",
            align: 'center',
            width: 150,
            render: (_, record) => (
                <AntSpace size="small" style={{ display: 'flex', justifyContent: 'center' }}>
                    <AntButton 
                        type="primary" 
                        size="small"
                        icon={<EyeOutlined style={{ fontSize: '16px' }} />} 
                        onClick={() => navigate(`/add-machinery`, { state: { editData: record, viewOnly: true } })}
                        style={{ 
                            backgroundColor: '#D91D3B', 
                            borderColor: '#D91D3B', 
                            width: '32px', 
                            height: '32px', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            borderRadius: '6px'
                        }}
                    />
                    <AntButton 
                        type="primary" 
                        size="small"
                        icon={<EditOutlined style={{ fontSize: '16px' }} />} 
                        onClick={() => navigate(`/add-machinery`, { state: { editData: record } })}
                        style={{ 
                            backgroundColor: '#D91D3B', 
                            borderColor: '#D91D3B', 
                            width: '32px', 
                            height: '32px', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            borderRadius: '6px'
                        }}
                    />
                    <AntButton 
                        type="primary"
                        danger
                        size="small"
                        icon={<DeleteOutlined style={{ fontSize: '16px' }} />} 
                        onClick={() => console.log("Delete", record.id)}
                        style={{ 
                            backgroundColor: '#D91D3B', 
                            borderColor: '#D91D3B', 
                            width: '32px', 
                            height: '32px', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            borderRadius: '6px'
                        }}
                    />
                </AntSpace>
            ),
        },
    ];

    return (
        <div className="white-container" style={{ padding: "10px" }}>
             <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                <Col xs={24} sm={8}>
                    <label className="block-label" style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Select Ship</label>
                    <AntSelect
                        placeholder="---- Select Ship ----"
                        style={{ width: '100%' }}
                        value={selectedShipId}
                        onChange={handleShipChange}
                    >
                        <Option value="">All Ships</Option>
                        {ships.map(ship => (
                            <Option key={ship.id} value={ship.id}>
                                {ship.vessel_name}
                            </Option>
                        ))}
                    </AntSelect>
                </Col>
                <Col xs={24} sm={8}>
                    <label className="block-label" style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Search</label>
                    <AntInput 
                        placeholder="Search machinery..." 
                        prefix={<SearchOutlined />} 
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                    />
                </Col>
            </Row>

            <div className="row" style={{ padding: "15px 10px", marginTop: '10px' }}>
                <div className="col-6" style={{ alignSelf: "center" }}>
                    <div className="theme-content-title text-left">
                        <h3 style={{ margin: 0 }}>Machinery Register</h3>
                    </div>
                </div>
                <div className="col-6" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <AntButton 
                        type="primary" 
                        icon={<PlusOutlined />} 
                        onClick={() => navigate("/add-machinery")}
                        className="save_btn"
                    >
                        Add Machinery
                    </AntButton>
                </div>
            </div>

            <AntTable 
                columns={columns} 
                dataSource={dataSource.filter(item => 
                    (item.machinery_name || item.machinary_name)?.toLowerCase().includes(searchText.toLowerCase()) ||
                    item.id?.toString().includes(searchText.toLowerCase())
                )} 
                loading={loader} 
                rowKey="id"
                bordered
                pagination={{ pageSize: 10 }}
                className="custom-table"
                style={{ marginTop: '10px' }}
            />
        </div>
    );
};

export default MachineryRegisterList;
